<nav
  #navbar
  [ngClass]="{
    'bg-white': open === true,
    'navbar-transparent': open === false
  }"
  class="navbar navbar-expand-lg navbar-absolute"
>
  <div class="container-fluid">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button
          (click)="minimizeSidebar()"
          class="btn btn-icon btn-round"
          id="minimizeSidebar"
        >
          <i
            class="fa fas fa-chevron-right text-center visible-on-sidebar-mini"
          ></i>
          <i
            class="fa fas fa-chevron-left text-center visible-on-sidebar-regular"
          ></i>
        </button>
      </div>
      <div (click)="sidebarToggle()" class="navbar-toggle">
        <button class="navbar-toggler" type="button">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <a class="navbar-brand" href="javascript:void(0)">{{ getTitle() }}</a>
    </div>
    <button
      (click)="open = !open"
      aria-controls="navigation-index"
      aria-expanded="false"
      aria-label="Toggle navigation"
      class="navbar-toggler"
      data-target="#navigation"
      data-toggle="collapse"
      type="button"
    >
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="navigation">
      <ul class="navbar-nav">
        <!--        <li class="nav-item btn-rotate dropdown">-->
        <!--          <a class="nav-link dropdown-toggle" (click)="viewNotifications()" href="javascript:;" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
        <!--            <i class="fa fas fa-bell fa-stack" [attr.data-count]="getNotificationBadge"></i>-->
        <!--            <p>-->
        <!--              <span class="d-lg-none d-md-block">Notifications</span>-->
        <!--            </p>-->
        <!--          </a>-->
        <!--        </li>-->
      </ul>
    </div>
  </div>
</nav>
